import React, { useState } from "react";
import { CircularProgress, Grid } from "@mui/material";
import { swalError, swalMessage } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import { Field, Form, Formik } from "formik";
import Link from "next/link";
import Select from "react-select";
import * as Yup from "yup";
import { ReactSVG } from "react-svg";
import { getAssets } from "@unisearch/helpers";
import styles from "./ielts_training.module.scss";

const selectStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    fontSize: "14px",
    padding: "5px",
    border: "1px solid #ebe9f1 !important",
    boxShadow: "0 !important",
    "&:hover": {
      border: "1px solid #ebe9f1 !important",
    },
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    const color = "#333";
    return {
      ...styles,
      fontSize: "13px",
      color: isSelected ? "#F47F20" : "#B5B5C3",
      backgroundColor: isSelected
        ? "#F5F6FC"
        : isFocused
        ? "#F5F6FC"
        : styles.backgroundColor,
      "&:hover": {
        backgroundColor: "#F5F6FC",
        color: "#F47F20",
      },
      cursor: isDisabled ? "not-allowed" : "pointer",
    };
  },
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  menu: (provided) => ({ ...provided, zIndex: 9999 }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#c2c2c2",
      fontSize: "13px",
    };
  },
};

const subjectHTML = `
<div
  style="
    font-size: 22px;
    font-weight: 600;
    line-height: 36px;
    padding: 0 50px;
    text-align: center;
    margin: 0 !important;
  "
>
  Your Registration was Successful | UniSearch <span style="color: #f47f20">Complete IELTS Training Program</span>
</div>
`;
const bodyHTML = `
<div style="padding: 0 50px; font-size: 12px">
  <p style="line-height: 1.8">Hi --NAME--,</p>
  <p style="line-height: 1.8">
  We’re delighted to have you be a part of UniSearch India - Chandigarh’s Complete IELTS Training Program!
  </p>

  <p style="line-height: 1.8">
  Our core mission at <span style="font-weight: 600;">UniSearch</span> is to support students every step of the way in their study abroad journey. Since hitting your target <span style="font-weight: 600;">IELTS Academic</span> scores is a key part of that journey, this one-month, in-person learning program is designed to take your English language abilities to the point where they need to be, to ace those exams.
  </p>

  <p style="line-height: 1.8">
  We look forward to seeing you in class on 18th July, 2022!
  </p>

  <p style="line-height: 1.8">
  <span style="font-weight: 600;">Location:</span> <br/>
  3rd Floor, S.C.O 68-69, <br/>
  Sector 17-B, Chandigarh.<br/>
  <span style="font-weight: 600;">Phone: </span> +91 8951621235 (Office hours: 9 am to 5 pm)<br/>
  <span style="font-weight: 600;">Email: </span> saista.parveen@myunisearch.com <br/>
  </p>

  <p style="line-height: 1.8">Do reach out to us if you have any questions or concerns.</p>

  <p style="line-height: 1.8">
    Warmly, <br />
    UniSearch
  </p>
</div>
`;

export const CompleteIeltsTraining = () => {
  const _init = {
    subject: "UniSearch Complete IELTS Training Program",
    subjectHTML,
    bodyHTML,

    fullName: "",
    contactNumber: "",
    email: "",
    cityName: "",

    planning: "",
    terms_and_condition: false,
  };

  const [initialState, setInitialState] = useState(_init);
  const [loading, setLoading] = useState(false);
  const isFormInable = (values, errors) => {
    if (
      errors &&
      Object.keys(errors).length === 0 &&
      values.fullName &&
      values.email
    ) {
      return false;
    } else {
      return true;
    }
  };

  const planningArr = [
    { value: "In 0-1 month", label: "In 0-1 month" },
    { value: "In 2-3 months", label: "In 2-3 months" },
    { value: "In 3 months’ time", label: "In 3 months’ time" },
    { value: "more", label: "more" },
  ];

  // form validation rules
  const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const validationSchema = Yup.object().shape({
    fullName: Yup.string().required("Name is required"),
    email: Yup.string()
      .email()
      .typeError("Please provide valid email")
      .required("Email is required"),
    contactNumber: Yup.string()
      .matches(phoneRegExp, "Contact Number number is not valid")
      .min(9)
      .max(15)
      .required("Contact Number is required"),
    cityName: Yup.string().required("Location is required"),
    terms_and_condition: Yup.bool().oneOf(
      [true],
      "You must accept the terms and conditions"
    ),
  });

  const handleRegister = async ({ ...values }, actions) => {
    delete values.terms_and_condition;
    setLoading(true);
    await API.post("public/incoming-leads", values).then((resp) => {
      if (resp.error) {
        swalError("Something went wrong");
        setLoading(false);
      }
      if (!resp.error) {
        swalMessage("Welcome!", "You have successfully registered");
        actions.resetForm();
        setLoading(false);
        // swalSuccess("You have successfully registered", "Welcome!");
      }
    });
  };

  return (
    <>
      <section className={styles.section_hero}>
        <div className="container">
          <div className="wrapper">
            <div className={styles.heading_wrapper}>
              <h2 className={styles.title} style={{ marginBottom: 5 }}>
                The Complete IELTS Training Program
              </h2>
              <p className="fw500" style={{ marginBottom: 15 }}>
                Chandigarh, UniSearch India
              </p>
              <p className={styles.sub_text}>
                This month-long course brings IELTS training to the physical
                classroom with the goal of maximising the one-to-one support and
                guidance <span className="fw600">UniSearch</span> strives to
                provide every student aiming to study abroad. The course will
                help you acquire in-depth knowledge of each of the IELTS
                modules, the techniques you need to solve different question
                types, and the tips to solve them in a given time limit. Once
                you complete this program, you will be able to sit your{" "}
                <span className="fw600">IELTS exams</span> with the confidence
                that you will succeed in hitting your target scores!
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.section_details}>
        <div className="container">
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={7}>
              <div className={styles.course_description_wrapper}>
                <h3 className={styles.course_desc_title}>Program Highlights</h3>
                <ul>
                  <li>
                    <div>
                      <h4 className={styles.para_title}>
                        UniSearch - IELTS - Student Offerings (Chandigarh)
                      </h4>
                      <p>
                        As a one-stop solution for students aiming to study
                        abroad, <span className="fw600">UniSearch</span> offers
                        complete, all-round support to build the strongest
                        applications possible - including hitting your target
                        IELTS scores. With us, you’re in the hands of experts.
                        Our courses are crafted and conducted by best-in-class,
                        certified IELTS trainers with a proven track record of
                        exceptional IELTS scores across India and overseas.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h4 className={styles.para_title}>
                        In-Person Classroom Training: One Month
                      </h4>
                      <p>
                        To better understand the ins and outs of the IELTS,
                        including its format, sections, question types, score
                        charts, and relevant skill sets and strategies, students
                        complete one month of in-person classroom training with
                        our experts. The classroom sessions will tackle all of
                        the four sections of the{" "}
                        <span className="fw600">
                          IELTS - Listening, Reading, Writing, and Speaking
                        </span>{" "}
                        - building students’ familiarity with the question types
                        and answer skills and strategies.
                      </p>
                      <p>
                        We understand that every student is different. This is
                        why it’s important to us to be able to give personalized
                        attention and feedback to every individual. To make sure
                        our coaches are able to give each student the fullest
                        attention, we cap off our classrooms at 25 students per
                        batch.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h4 className={styles.para_title}>
                        Additional Support After Classroom Training
                      </h4>
                      <p>
                        <strong className={"color-orange"}>Mock Tests: </strong>{" "}
                        Students become familiar with the real exam and get
                        hands-on understanding of their performance and progress
                        by sitting for{" "}
                        <span className="fw600">
                          8 full-length practice tests
                        </span>{" "}
                        designed by the official IELTS test administrators.{" "}
                        <span className="fw600">UniSearch</span> also offers
                        section-based tests for each of the 4 IELTS modules
                        during classroom training. These include one-to-one
                        Speaking and Writing practice, simulating the real exam
                        with full evaluations of performance and guidance on how
                        to improve
                      </p>
                      <p>
                        <strong className={"color-orange"}>
                          Doubt-Clearing Sessions:
                        </strong>{" "}
                        <span className="fw600">UniSearch</span> offers
                        unlimited one-to-one and group consulting sessions for
                        two months, to address each and every concern and
                        question students have while sitting for their IELTS
                      </p>
                      <p>
                        <strong className={"color-orange"}>
                          60-Day Course Validity:
                        </strong>{" "}
                        The standard one month classroom training is designed to
                        cover all bases for our students to be test-ready for
                        their IELTS. However, since we understand that every
                        student learns differently and may seek additional
                        support, the course is fully valid for 60 days, during
                        which time students can retake classroom training and
                        attend one-to-one doubt-clearing sessions (subject to
                        available batch schedules and respective faculty slots)
                      </p>
                      <p>
                        <strong className={"color-orange"}>
                          Study Materials:
                        </strong>{" "}
                        We use, reference, and recommend official IELTS test
                        preparation materials for our students to provide the
                        most accurate and effective foundation for their test
                        day success
                      </p>
                    </div>
                  </li>
                </ul>
              </div>

              {/* what_get_wrapper */}
              <div className={styles.what_get_wrapper}>
                <div className={styles.what_geat_head}>What You Get</div>
                <div className={styles.what_geat_body}>
                  <ul>
                    <li>
                      <ReactSVG
                        src={getAssets(
                          "assets/images/elearning/video-lesson.svg"
                        )}
                      />
                      <span>In-Person Classroom Training</span>
                    </li>
                    <li>
                      <ReactSVG
                        src={getAssets("assets/images/elearning/mock-exam.svg")}
                      />
                      <span>Official Study Materials</span>
                    </li>
                    <li>
                      <ReactSVG
                        src={getAssets(
                          "assets/images/elearning/study-materials.svg"
                        )}
                      />
                      <span>Full-Length and Sectional Tests</span>
                    </li>
                    <li>
                      <ReactSVG
                        src={getAssets(
                          "assets/images/elearning/tutor-support.svg"
                        )}
                      />
                      <span>Doubt Clearing Sessions</span>
                    </li>
                    <li>
                      <ReactSVG
                        src={getAssets("assets/images/elearning/guidence.svg")}
                      />
                      <span>Personalized Guidance</span>
                    </li>
                    <li>
                      <ReactSVG
                        src={getAssets(
                          "assets/images/elearning/tutor-support.svg"
                        )}
                      />
                      <span>One-on-One Speaking Evaluations</span>
                    </li>
                    <li>
                      <ReactSVG
                        src={getAssets(
                          "assets/images/elearning/tutor-support.svg"
                        )}
                      />
                      <span>One-on-One Writing Evaluations</span>
                    </li>
                  </ul>
                </div>
              </div>
            </Grid>

            {/* right side */}
            <Grid item xs={12} sm={12} md={5}>
              <div className={styles.course_hithlights_wrapper}>
                <div className={styles.heighlight_head}>
                  <img
                    src={getAssets(
                      "assets/images/elearning/Test-Prep-IELTS-Regular.png"
                    )}
                    alt="Course Details"
                  />
                </div>

                <div className={styles.heighlight_body}>
                  <div className={styles.course_price_highlight}>
                    <div className={styles.course_price_now}>Rs 4999/-</div>
                    <small>(Chandigarh, UniSearch India)</small>
                  </div>

                  <div className="fw600" style={{ marginBottom: "20px" }}>
                    Classes Starting 18th July, 2022
                  </div>

                  <Link legacyBehavior href="#form">
                    <a
                      className={`btn btn-secondary btn-bg btn-full ${styles.action_btn}`}
                    >
                      Enrol Now
                    </a>
                  </Link>

                  <div className={styles.course_hithlights}>
                    <ul>
                      <li>
                        <span className={styles.first_child}>
                          One month training
                        </span>
                      </li>
                      <li>
                        <span className={styles.first_child}>
                          3-hour in-person classroom sessions (Mon-Fri)
                        </span>
                      </li>
                      <li>
                        <span className={styles.first_child}>
                          8 official mock test evaluations
                        </span>
                      </li>
                      <li>
                        <span className={styles.first_child}>
                          One-to-one Writing & Speaking evaluation from experts
                        </span>
                      </li>
                      <li>
                        <span className={styles.first_child}>
                          One-to-one doubt-clearing sessions
                        </span>
                      </li>
                      <li>
                        <span className={styles.first_child}>
                          2-month course validity
                        </span>
                      </li>
                      <li>
                        <span className={styles.first_child}>
                          In-class vocabulary building and grammar practice
                        </span>
                      </li>
                      <li>
                        <span className={styles.first_child}>
                          In-class sectional and practice tests
                        </span>
                      </li>
                      <li>
                        <span className={styles.first_child}>
                          Exercises to address Speaking section challenges
                        </span>
                      </li>
                      <li>
                        <span className={styles.first_child}>
                          9-Band tips to prepare and manage time for IELTS exams
                        </span>
                      </li>
                      <li>
                        <span
                          className={styles.first_child}
                          style={{ fontWeight: "normal" }}
                        >
                          *Only official IDP content used for practice and
                          teaching
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </section>

      <section id="form">
        <div className="container">
          <div className={styles.form_wrapper}>
            <div className={styles.form_title_wrapper}>
              <h2>
                Interested in Signing Up for Your Complete IELTS Training
                Program
              </h2>
              <p>Just fill in your details and we’ll call you back.</p>
            </div>

            <Formik
              initialValues={initialState}
              enableReinitialize={true}
              validationSchema={validationSchema}
              onSubmit={(values, actions) => {
                handleRegister(values, actions);
              }}
            >
              {({ handleSubmit, values, setFieldValue, errors, touched }) => (
                <Form className="form" autoComplete="off">
                  <Grid container columnSpacing={{ xs: 2, sm: 2, md: 4 }}>
                    <Grid item xs={12} sm={12} md={12}>
                      <div className={styles.form_group}>
                        <label>
                          Full Name <span className={styles.asterisk}>*</span>
                        </label>
                        <input
                          id="fullName"
                          name="fullName"
                          placeholder="Full Name"
                          type="text"
                          value={values.fullName ?? ""}
                          onChange={(e) => {
                            setFieldValue("fullName", e.target.value);
                            touched.fullName = true;
                          }}
                        />
                        {errors.fullName && touched.fullName ? (
                          <div className={styles.error_msg}>
                            {errors.fullName}
                          </div>
                        ) : null}
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                      <div className={styles.form_group}>
                        <label>
                          Email Address
                          <span className={styles.asterisk}>*</span>
                        </label>
                        <input
                          id="email"
                          name="email"
                          placeholder="Type Your Email "
                          type="email"
                          value={values.email ?? ""}
                          onChange={(e) => {
                            setFieldValue("email", e.target.value);
                            touched.email = true;
                          }}
                        />
                        {errors.email && touched.email ? (
                          <div className={styles.error_msg}>{errors.email}</div>
                        ) : null}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <div className={styles.form_group}>
                        <label>
                          Phone Number
                          <span className={styles.asterisk}>*</span>
                        </label>
                        <input
                          id="contactNumber"
                          name="contactNumber"
                          placeholder="Type Your Phone Number"
                          type="number"
                          value={values.contactNumber ?? ""}
                          onChange={(e) => {
                            setFieldValue("contactNumber", e.target.value);
                            touched.contactNumber = true;
                          }}
                        />
                        {errors.contactNumber && touched.contactNumber ? (
                          <div className={styles.error_msg}>
                            {errors.contactNumber}
                          </div>
                        ) : null}
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                      <div className={styles.form_group}>
                        <label>
                          Location <span className={styles.asterisk}>*</span>
                        </label>
                        <input
                          id="cityName"
                          name="cityName"
                          placeholder="Type Your Location"
                          type="text"
                          value={values.cityName ?? ""}
                          onChange={(e) => {
                            setFieldValue("cityName", e.target.value);
                            touched.cityName = true;
                          }}
                        />
                        {errors.cityName && touched.cityName ? (
                          <div className={styles.error_msg}>
                            {errors.cityName}
                          </div>
                        ) : null}
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                      <div className={styles.form_group}>
                        <label>
                          When are you planning to sit for your IELTS exam?
                        </label>
                        <Select
                          instanceId="planning"
                          styles={selectStyles}
                          placeholder="Please Select"
                          options={planningArr ?? []}
                          name="planning"
                          onChange={(item) => {
                            setFieldValue("planning", item.value);
                            touched.planning = true;
                          }}
                          value={
                            planningArr
                              ? planningArr.filter(
                                  (item) => item.value == values?.planning
                                )
                              : {}
                          }
                        />
                      </div>
                    </Grid>
                  </Grid>

                  <div className={styles.checkbox_container_wrapper}>
                    <div className={styles.checkbox_with_error_wrapper}>
                      <div className={styles.checkbox_wrapper}>
                        <label
                          className={`${styles.checkbox_lebel} checkbox_container`}
                          html="terms"
                        >
                          <Field
                            id="terms"
                            type="checkbox"
                            name="terms_and_condition"
                            className="checkbox disable-team team_values"
                            value={true}
                            checked={
                              values.terms_and_condition &&
                              values.terms_and_condition === true
                                ? true
                                : false
                            }
                            onChange={(event) => {
                              setFieldValue(
                                "terms_and_condition",
                                event.target.checked
                              );
                              touched.terms_and_condition = true;
                            }}
                          />
                          <span
                            className="checkbox_checkmark"
                            style={{ marginLeft: "0px", marginTop: "2px" }}
                          ></span>
                          <span>I agree to UniSearch</span>
                        </label>

                        <Link legacyBehavior href="/terms-and-conditions">
                          <a className={styles.term_link}>Terms</a>
                        </Link>
                        <span>and</span>
                        <Link legacyBehavior href="/privacy-policy">
                          <a className={styles.term_link}>Privacy Policy.</a>
                        </Link>
                      </div>

                      {errors?.terms_and_condition &&
                      touched?.terms_and_condition ? (
                        <div className={styles.error_msg}>
                          {errors.terms_and_condition}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <button
                    type="submit"
                    className={`${
                      styles.register_btn
                    } btn btn-secondary btn-bg btn-full ${
                      loading || isFormInable(values, errors)
                        ? styles.disabled
                        : "enable"
                    } `}
                    onClick={handleSubmit}
                    disabled={
                      loading || isFormInable(values, errors) ? true : false
                    }
                  >
                    {loading && (
                      <CircularProgress size="16px" color="inherit" />
                    )}
                    Register Now!
                  </button>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </section>
    </>
  );
};

export default CompleteIeltsTraining;
